var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 26,
    viewBox: "0 0 8 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99822 6.58139C5.53947 6.58139 6.78891 5.33195 6.78891 3.7907C6.78891 2.24944 5.53947 1 3.99822 1C2.45696 1 1.20752 2.24944 1.20752 3.7907C1.20752 5.33195 2.45696 6.58139 3.99822 6.58139Z",
    fill: "white",
    stroke: "#EE3A43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99822 15.5116C5.53947 15.5116 6.78891 14.2621 6.78891 12.7209C6.78891 11.1796 5.53947 9.93018 3.99822 9.93018C2.45696 9.93018 1.20752 11.1796 1.20752 12.7209C1.20752 14.2621 2.45696 15.5116 3.99822 15.5116Z",
    fill: "white",
    stroke: "#EE3A43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99822 24.9998C5.53947 24.9998 6.78891 23.7504 6.78891 22.2092C6.78891 20.6679 5.53947 19.4185 3.99822 19.4185C2.45696 19.4185 1.20752 20.6679 1.20752 22.2092C1.20752 23.7504 2.45696 24.9998 3.99822 24.9998Z",
    fill: "white",
    stroke: "#EE3A43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2ae45d3f11d18b6bc7a4cb4257041a39.svg";
export { ForwardRef as ReactComponent };